// TODO: Create mapper for the video and image
export const contentMapper = (content, type) => {
    switch (type) {
        case 'ColumnsBlock':
            return columnsBlockMapper(content);
        case 'PromoMainBlock':
            return promoBlockMapper(content);
        case 'LogosBlock':
            return logosBlockMapper(content);
        case 'TitleBlock':
            return titleBlockMapper(content);
        case 'CTABlock':
            return ctaBlockMapper(content);
        case 'ParallaxBlock':
            return parallaxBlockMapper(content);
        case 'TabsBlock':
            return tabsBlockMapper(content);
        case 'HeroHomeBlock':
            return heroHomeBlockMapper(content);
        case 'HighlightsBlock':
            return highlightsBlockMapper(content);
        case 'ResourcePreviewCardsBlock':
            return resourcePreviewCardsBlockMapper(content);
        case 'TwoColumnBlock':
            return twoColumnBlockMapper(content);
    }
};
const columnsBlockMapper = (content) => {
    const items = content.items?.expandedValue
        ?.map((item) => {
        if (!item)
            return null;
        const mappedItem = {
            name: item.name,
            contentType: item.contentType,
            title: item.title.value,
            subtitle: item.subtitle?.value,
            backgroundColor: item.backgroundColor?.value,
            primaryCTA: item.primaryCTA
                ? {
                    label: item.primaryCTA.label.value || '',
                    style: item.primaryCTA.style.value || '',
                    target: item.primaryCTA.target.value || '',
                    url: item.primaryCTA.url?.value || ''
                }
                : undefined,
            links: item.linksCTA?.expandedValue?.map((cta) => ctaBlockMapper(cta)),
            video: item.video?.expandedValue
                ? {
                    name: item.video.expandedValue.name || '',
                    contentType: item.video.expandedValue.contentType,
                    url: item.video.expandedValue.url,
                    autoplay: item.video.expandedValue.autoplay?.value === true,
                    mimeType: item.video.expandedValue.mimeType?.value,
                    displayControls: item.video.expandedValue.displayControls?.value === true
                }
                : undefined,
            iconImage: mapContentReferenceToImage(item.iconImage?.expandedValue),
            logoImage: mapContentReferenceToImage(item.logoImage?.expandedValue)
        };
        return mappedItem;
    })
        .filter((item) => item !== null);
    return {
        items: items || [],
        blockBackgroundColor: content?.blockBackgroundColor?.value || ''
    };
};
const mapContentReferenceToImage = (expanded) => {
    if (!expanded) {
        return undefined;
    }
    return {
        name: expanded.name || '',
        contentType: expanded.contentType,
        url: expanded.url,
        description: expanded.description?.value,
        altText: expanded.alt?.value
    };
};
const promoBlockMapper = (content) => {
    return {
        name: content.name,
        contentType: content.contentType,
        title: content.title.value || '',
        backgroundColor: content?.backgroundColor?.value || '',
        blockBackgroundColor: content?.blockBackgroundColor?.value || '',
        subtitle: content?.subtitle?.value || '',
        mainCta: content?.mainCta ? ctaBlockMapper(content.mainCta) : undefined,
        imageAlignment: content?.imageAlignment?.value || '',
        image: content.image?.expandedValue
            ? {
                name: content.image.expandedValue.name || '',
                contentType: content.image.expandedValue.contentType,
                url: content.image.expandedValue.url,
                description: content.image.expandedValue.description?.value,
                altText: content.image.expandedValue.alt?.value
            }
            : undefined
    };
};
const logosBlockMapper = (content) => {
    const logos = content.logos?.expandedValue?.map(logo => {
        return {
            url: logo.url,
            altText: logo.altText?.value || ''
        };
    });
    return {
        logos: logos || [],
        backgroundColor: content.backgroundColor?.value
    };
};
const titleBlockMapper = (content) => {
    return {
        backgroundColor: content.backgroundColor?.value || '',
        subtitle: content.subtitle?.value || '',
        title: content.title?.value || '',
        cta: ctaBlockMapper(content.cta),
        hideSquaresImage: content.hideSquaresImage?.value === true
    };
};
const ctaBlockMapper = (content) => {
    return {
        url: content?.url?.value || null,
        label: content?.label?.value || '',
        target: content?.target?.value || '',
        style: content?.style?.value || ''
    };
};
const tabsBlockMapper = (content) => {
    const tabs = content.tabItems?.expandedValue?.map(tab => {
        return {
            title: tab.title.value,
            description: tab.description.value,
            tabContent: tab.tabContent.value
        };
    });
    return {
        items: tabs || [],
        backgroundColor: content.backgroundColor?.value,
        title: content.title?.value,
        description: content.description?.value,
        hideSquaresImage: content.hideSquaresImage?.value === true
    };
};
const parallaxBlockMapper = (content) => {
    const properties = {
        label: content.label.value,
        title: content.title.value,
        subtitle: content.subtitle.value,
        backgroundColor: content.backgroundColor?.value,
        hideSquaresImage: content.hideSquaresImage?.value === true,
        contentCards: content.contentCards?.expandedValue?.map(card => ({
            label: card.label.value || '',
            title: card.title.value || '',
            description: card.description.value || '',
            image: card.image
                ? {
                    name: card.image?.expandedValue?.name || '',
                    contentType: card.image?.expandedValue?.contentType,
                    url: card.image?.expandedValue?.url,
                    description: card.image?.expandedValue?.description?.value,
                    altText: card.image?.expandedValue?.alt?.value
                }
                : undefined,
            ctaLinks: card.ctaLinks?.value.map(cta => ({
                label: cta.text,
                target: cta.target || '',
                url: cta.href || ''
            }))
        }))
    };
    return properties;
};
const heroHomeBlockMapper = (content) => {
    return {
        title: content.title.value,
        description: content.description?.value,
        backgroundColor: content.backgroundColor?.value,
        hideBackgroundOverlay: content.hideBackgroundOverlay?.value === true,
        hideBackgroundSquares: content.hideBackgroundSquares?.value === true,
        buttonsCTAs: content.buttonsCTAs?.expandedValue?.map(cta => ctaBlockMapper(cta)) ?? [],
        video: content.video?.expandedValue
            ? {
                name: content.video.expandedValue.name || '',
                contentType: content.video.expandedValue.contentType,
                url: content.video.expandedValue.url,
                autoplay: content.video.expandedValue.autoplay?.value === true,
                mimeType: content.video.expandedValue.mimeType?.value,
                displayControls: content.video.expandedValue.displayControls?.value === true
            }
            : undefined,
        image: content.image?.expandedValue
            ? {
                name: content.image.expandedValue.name || '',
                contentType: content.image.expandedValue.contentType,
                url: content.image.expandedValue.url,
                description: content.image.expandedValue.description?.value,
                altText: content.image.expandedValue.alt?.value
            }
            : undefined,
        highlightBlock: content.highlightBlock?.expandedValue?.map(item => highlightsBlockMapper(item))[0] ?? undefined
    };
};
const mapImage = (image) => {
    if (!image)
        return undefined;
    return {
        name: image.value?.name || '',
        contentType: image.value?.contentType,
        url: image.value?.url,
        description: image.value?.description?.value,
        altText: image.value?.alt?.value
    };
};
const mapLink = (link) => {
    return {
        label: link.text?.value || '',
        target: link.target?.value || '',
        url: link.url?.value || ''
    };
};
const mapHighlightTab = (tabData) => {
    return {
        backgroundColor: tabData.backgroundColor?.value,
        title: tabData.title?.value,
        subtitle: tabData.subtitle?.value,
        image: mapImage(tabData.image),
        link: mapLink(tabData.link)
    };
};
const highlightsBlockMapper = (content) => {
    return {
        highlightTabOne: mapHighlightTab(content.highlightTabOne),
        highlightTabTwo: mapHighlightTab(content.highlightTabTwo),
        highlightTabThree: mapHighlightTab(content.highlightTabThree),
        highlightTabFour: mapHighlightTab(content.highlightTabFour)
    };
};
const resourcePreviewCardsBlockMapper = (content) => {
    return {
        backgroundColor: content.backgroundColor?.value || '',
        cardVariant: content.cardVariant?.value || '',
        description: content.description?.value || '',
        title: content.title?.value || '',
        cardWidth: content.cardWidth?.value || '',
        cardBackgroundColor: content.cardBackgroundColor?.value || '',
        blockId: content.contentLink.id,
        seeAll: linkItemMapper(content.seeAll),
        cardImageBackgroundColor: content.cardImageBackgroundColor?.value || '',
        hideSquaresImage: content.hideSquaresImage?.value === true
    };
};
const linkItemMapper = (content) => {
    return {
        href: content?.value?.href,
        target: content?.value?.target,
        text: content?.value?.text,
        title: content?.value?.title
    };
};
const twoColumnBlockMapper = (content) => {
    return {
        title: content.title?.value || '',
        subtitle: content.subtitle?.value || '',
        contentColumn: content.contentColumn?.value || '',
        blockBackgroundColor: content.blockBackgroundColor?.value || '',
        buttonsCTAs: content.buttonsCTAs?.expandedValue?.map(cta => ctaBlockMapper(cta)) || [],
        columnAlignment: content.columnAlignment?.value || ''
    };
};
